/**
 * Navigates the current window to the given URL.
 * Kept in its own module so tests can spy on it, as jsdom no longer allows mocking window.location.
 */
export const redirectTo = (url: string): void => {
  window.location.assign(url)
}
